import React from 'react';
import '../../css/components/Features.css';

const Features = () => {
  return (
    <section className="features" id="features">
      <div className="container features-container">
        <div className="features-header">
          <div className="section-badge animate-fade-in">
            <span className="badge-icon">✨</span>
            <span className="badge-text">How It Works</span>
          </div>
          <h2 className="section-title animate-fade-in">
            The easiest way to <span className="text-gradient">write smarter</span> in Chrome
          </h2>
          <p className="section-subtitle animate-fade-in">
            Get AI assistance without ever leaving your current tab or disrupting your workflow
          </p>
        </div>
        
        <div className="features-grid">
          <div className="feature-card animate-slide-up">
            <div className="feature-icon-wrapper">
              <div className="feature-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 20h9"></path>
                  <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
                </svg>
              </div>
              <div className="feature-step">01</div>
            </div>
            <div className="feature-content">
              <h3 className="feature-title">Type your prompt with a trigger tag</h3>
              <p className="feature-description">
                Just start with your custom tag (like &lt;a&gt;&lt;/a&gt;) followed by your request.<br/>
                For example: <code>&lt;a&gt; Write a quick product description &lt;/a&gt;</code>
              </p>
            </div>
          </div>
          
          <div className="feature-card animate-slide-up" style={{animationDelay: '0.1s'}}>
            <div className="feature-icon-wrapper">
              <div className="feature-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                  <path d="M12 16v-4"></path>
                  <path d="M12 8h.01"></path>
                </svg>
              </div>
              <div className="feature-step">02</div>
            </div>
            <div className="feature-content">
              <h3 className="feature-title">SmartGPT processes your request</h3>
              <p className="feature-description">
                Our AI understands your prompt and generates a response based on your specific request, all within milliseconds.
              </p>
            </div>
          </div>
          
          <div className="feature-card animate-slide-up" style={{animationDelay: '0.2s'}}>
            <div className="feature-icon-wrapper">
              <div className="feature-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                  <polyline points="22 4 12 14.01 9 11.01"></polyline>
                </svg>
              </div>
              <div className="feature-step">03</div>
            </div>
            <div className="feature-content">
              <h3 className="feature-title">Get instant AI-generated content</h3>
              <p className="feature-description">
                The AI response replaces your tag, seamlessly integrating into your workflow without disruption or tab switching.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;